import isMainDomain from 'App/helpers/misc/domain/isMainDomain'
import isReservedJustoSubdomain from 'App/helpers/misc/domain/isReservedJustoSubdomain'

export default function() {
  if (isMainDomain() || isReservedJustoSubdomain()) return null

  if (localStorage.getItem('salesPointDomain')) {
    return localStorage.getItem('salesPointDomain')
  } else {
    return window.location.hostname
  }
}
